import script from "./C4Summary.vue?vue&type=script&lang=js"
export * from "./C4Summary.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__